import { render, staticRenderFns } from "./teamWork.vue?vue&type=template&id=4b474378&lang=pug&"
import script from "./teamWork.vue?vue&type=script&lang=js&"
export * from "./teamWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports